import React from 'react';
import { ModalContent, ModalHeader, Typography } from 'common/components';

export const Projects = () => (
  <>
    <ModalHeader title="Более 1 млн проектов" />
    <ModalContent variant="simple">
      <Typography adaptive={false} variant="m" size="body_long">
        Наша команда&nbsp;&mdash; опытные эксперты по&nbsp;ремонту и&nbsp;дизайну ванных комнат.
        Мы&nbsp;учитываем все нюансы, предлагаем современные решения и&nbsp;работаем только с&nbsp;качественными
        материалами от&nbsp;ведущих производителей. Сделаем всё быстро, аккуратно и&nbsp;в&nbsp;срок.
      </Typography>
    </ModalContent>
  </>
);
